export const zhAndEnWord = {
    zh: {
        pdf: '下载PDF',
        feedback: '反馈问题',
        help: '该文档内容对你有帮助么？',
        modal: {
            feedbackTitle: '意见反馈',
            feddbackDesc:
                '很抱歉给您带来不好的体验，您的问题可以在此反馈， 或加入官方QQ群（432676488）进行咨询，我们会第一时间进行响应',
            issueAndSuggest: '问题与意见',
            partImage: '图片截图（选填）',
            upload: '上传图片',
            cancel: '取消',
            submit: '确认'
        }
    },
    en: {
        pdf: 'Download PDF',
        feedback: 'Quick Feedback',
        help: 'Was this helpful?',
        modal: {
            feedbackTitle: 'Send Feedback',
            feddbackDesc:
                'We are sorry for any inconvenience caused. You can elaborate on the issue here or tell us in the official Tencent QQ group (432676488). We will give a response as soon as possible.',
            issueAndSuggest: 'Describe the issue',
            partImage: 'Screenshot (optional)',
            upload: 'Upload',
            cancel: 'Cancel',
            submit: 'Submit'
        }
    }
};
